/**
 * Dev-only: copy exact model system + user text for the current AI run
 * For Media Devoted | Created By Ciro Autiero
 */

import { ClipboardCopy, Loader2 } from 'lucide-react';

import { Button } from '@/components/ui';

interface PreviewDevExactPromptButtonProps {
  onCopy: () => void | Promise<void>;
  pending?: boolean;
}

export function PreviewDevExactPromptButton({ onCopy, pending }: PreviewDevExactPromptButtonProps) {
  if (!import.meta.env.DEV) return null;
  return (
    <Button
      type="button"
      variant="ghost"
      size="sm"
      className="h-6 gap-0.5 px-1.5 text-[10px] text-muted-foreground"
      disabled={pending}
      title="Copy exact system + user strings sent to the model (this country + group + batch size)."
      onClick={() => void onCopy()}
    >
      {pending ? (
        <Loader2 className="h-3 w-3 animate-spin shrink-0" aria-hidden />
      ) : (
        <ClipboardCopy className="h-3 w-3 shrink-0" aria-hidden />
      )}
      Prompt
    </Button>
  );
}
